// config.js
//const API_URL = "https://146.190.170.8:3000"; // Cambia esto por la URL de tu backend

//const API_URL = "http://localhost:3001";
//const API_URL = "https://146.190.170.8:3000";

//const API_URL = "https://matchgame.cloud"; 
const API_URL = "https://matchgame.site"; 
export default API_URL;
